import * as angular from 'angular';

import { AlarmsHeatMapConfiguration } from './alarmsHeatMap.configuration';
import { PropertyType, ContextualField, ComponentDefinition, Dashboard } from '../../models';
import * as Fields from '../../common/helpers/contextual';

class AlarmsHeatMapContextualController implements angular.IComponentController {
    configuration: AlarmsHeatMapConfiguration;
    properties: ContextualField[];

    readonly dashboards: Dashboard[];
    readonly formController: angular.IFormController;
    readonly isBindable: boolean;

    private _coloringScaleProperty: ContextualField;
    private _multiGroupProperty: ContextualField;
    private _multiGroupTypeProperty: ContextualField;

    static $inject = [];

    $onInit() {
        const tmp = (this.dashboards || [])
            .map(d => { return { key: d.guid, value: d.name }; })
            .sort((a, b) => a.value > b.value ? 1 : -1);
        const dashboardsVm = [{ key: '', value: 'None' }].concat(tmp);

        const isScaleDisabled = !this.configuration.isColoring;
        this._coloringScaleProperty = {
            modelName: 'coloringScale',
            propertyType: PropertyType.Text,
            label: 'Maximum',
            placeholder: 'Maximum',
            propertyName: 'coloringScaleProperty',
            required: !isScaleDisabled,
            icon: 'fa-long-arrow-up',
            disabled: isScaleDisabled,
            messages: [
                { key: 'required', value: 'Maximum is required' },
                { key: 'number', value: 'Maximum must be an integer greater than 0' }
            ],
            onChange: (value) => {
                const isRequired = !!value;
                const isNumber = value && !isNaN(value) && Number(value) > 0;
                this.formController['coloringScaleProperty'].$setValidity('required', isRequired);
                this.formController['coloringScaleProperty'].$setValidity('number', isNumber);
            }
        };
        this._multiGroupProperty = {
            modelName: 'groupGuids',
            propertyType: PropertyType.MultiGroup,
            label: 'Groups',
            propertyName: 'groupGuidsProperty',
            required: false,
            disabled: this.configuration.isBoundToGroup,
            extraData: {},
            icon: 'fa-sitemap'
        };

        this._multiGroupTypeProperty = angular.copy(Fields.GroupTypes);
        this._multiGroupTypeProperty.disabled = this.configuration.isBoundToGroup;

        this.properties = [
            {
                modelName: 'isBoundToGroup',
                propertyType: PropertyType.Boolean,
                label: 'Bind',
                placeholder: 'Bind',
                propertyName: 'isBoundToGroupProperty',
                required: false,
                disabled: !this.isBindable,
                icon: 'fa-anchor',
                onChange: value => {
                    this._multiGroupProperty.disabled = value;
                    this._multiGroupTypeProperty.disabled = value;
                    if (value) {
                        this.configuration.groupGuids = [];
                        this.configuration.groupTypes = [];
                    }
                }
            },
            angular.copy(Fields.IncludeChildren),
            this._multiGroupProperty,
            this._multiGroupTypeProperty,
            {
                modelName: 'severities',
                propertyType: PropertyType.Severities,
                label: 'Severities',
                propertyName: 'severitiesProperty',
                required: false,
                icon: 'fa-bell'
            }, {
                modelName: 'isChildrenStacked',
                propertyType: PropertyType.Boolean,
                label: 'Sum up children',
                placeholder: 'Sum up children',
                propertyName: 'isChildrenStackedProperty',
                required: false,
                icon: 'fa-child',
                iconText: '\u2211'
            }, {
                modelName: 'isColoring',
                propertyType: PropertyType.Boolean,
                label: 'Color cells',
                placeholder: 'Color cells',
                propertyName: 'isColoringProperty',
                required: false,
                icon: 'fa-paint-brush',
                onChange: (value) => {
                    this._coloringScaleProperty.disabled = !value;
                    if (!value) {
                        this.formController['coloringScaleProperty'].$setValidity('required', true);
                    }
                }
            },
            this._coloringScaleProperty,
            {
                modelName: 'dashboardGuid',
                propertyType: PropertyType.Select,
                label: 'Dashboard',
                propertyName: 'dashboardGuidProperty',
                required: false,
                icon: 'fa-th-large',
                extraData: {
                    options: dashboardsVm
                }
            }
        ];
    }
}

export const wtAlarmsHeatMapContextual: ComponentDefinition = {
    componentId: 'wtAlarmsHeatMapContextual',
    controller: AlarmsHeatMapContextualController,
    controllerAs: 'vm',
    template: require('./alarmsHeatMap.contextual.html'),
    bindings: {
        configuration: '=',
        dashboards: '<',
        formController: '<',
        isBindable: '<'
    }
};